function useProcessSchema() {
  function processSchema(schema: any, element: any) {
  // Hacemos una copia superficial del schema y de sus propiedades para evitar mutar el original.
  // Evitamos clonación profunda por rendimiento y clonamos sólo los nodos que modificamos.
  let processedSchema = { ...schema, properties: { ...(schema?.properties || {}) } };

    // Recorremos todas las propiedades del esquema
    Object.keys(processedSchema.properties).forEach((key) => {
      // Hacemos una copia de la propiedad a nivel superficial antes de modificarla
      const originalProp = processedSchema.properties[key];
      let property = { ...originalProp };
      processedSchema.properties[key] = property;

      // Si la propiedad tiene la propiedad 'show'
      if (property.hasOwnProperty("show")) {
        // Si show es una función, la ejecutamos pasandole el element
        if (typeof property.show === "function") {
          const showResult = property.show(element);
          // debug logging opcional
          // debug removed
          // sustituimos por booleano y actuamos como en el caso no-función
                if (!showResult) {
            element[key] = property.default;
            delete processedSchema.properties[key];
            return; // saltar al siguiente key
          }
          // si mostramos el campo, eliminamos la propiedad auxiliar 'show' para no dejarla en el schema
          delete property.show;
        } else {
                    if (!property.show) {
            // Si 'show' es falso, eliminamos la propiedad del esquema
            element[key] = property.default;
            delete processedSchema.properties[key];
          }
          // Si 'show' es verdadero, eliminamos la propiedad 'show' del esquema
          else {
            delete property.show;
          }
        }
      }

      // Si la propiedad es un objeto, aplicamos la recursividad
      if (
        processedSchema.properties[key] &&
        property.type === "object" &&
        property.properties
      ) {
            processedSchema.properties[key] = processSchema(property, element[key] || {});
      }

      // Si la propiedad es un array de objetos, aplicamos la recursividad a cada elemento
      if (
        element &&
        processedSchema.properties[key] &&
        property.type === "array" &&
        property.items &&
        property.items.type === "object" &&
        property.items.properties
      ) {
  let items = property.items ? { ...property.items } : undefined;
  let newElement = element[key] ? element[key] : {};
  if (items) processedSchema.properties[key].items = processSchema(items, newElement);
      }
    });

    return processedSchema;
  }

  return (schema: any, element: any) => {
    return processSchema(schema, element);
  };
}

export default useProcessSchema;
